import { Text } from "../externalComponents/tailwind/text";
import { Handle, Position } from "reactflow";
import { Badge } from "../externalComponents/tailwind/badge";
import { conditionOperators } from "./utils-conditionNode/condition-operators.const";

function ConditionNode({ id, data }) {
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const totalMinutes = data.valueStartingPeriodInMinutes ?? 0;
  const conditionDays = Math.floor(totalMinutes / 1440);
  const conditionHours = Math.floor((totalMinutes - conditionDays * 1440) / 60);
  const conditionMinutes =
    totalMinutes - conditionDays * 1440 - conditionHours * 60;

  return (
    <div className="condition-node" onClick={() => data.clickNode(id)}>
      <Handle type="target" position={Position.Left} />
      <br />
      {data.property === null ? (
        <Text className="text-xs">Condition...</Text>
      ) : (
        <div className="mb-3 flex items-center justify-center flex-col">
          <div className="flex">
            <Text className="text-xs">
              {`${capitalizeFirstLetter(data.property)}${data.property === "random split" ? ":" : ""}`}
            </Text>
            {data.operator && (
              <div className="ml-1">
                <Text className="text-xs">{data.operator}</Text>
              </div>
            )}
            {data.valueTag.name && (
              <div className="ml-1">
                <Text className="text-xs">{data.valueTag.name}</Text>
              </div>
            )}
            {data.valueBoolean !== null && (
              <div className="ml-1">
                <Text className="text-xs">
                  {data.valueBoolean === true
                    ? "true"
                    : data.valueBoolean === false
                      ? "false"
                      : ""}
                </Text>
              </div>
            )}
          </div>
          {(data.property === "has placed order" ||
            data.property === "contact was created") &&
            data.operator && (
              <div className="ml-1 mt-1">
                <Text className="text-xs !whitespace-nowrap">
                  {`${conditionDays} ${conditionDays > 1 ? "days" : "day"}, 
              ${conditionHours} ${conditionHours > 1 ? "hours" : "hour"}, 
              ${conditionMinutes} ${
                conditionMinutes > 1 ? "minutes" : "minute"
              }`}
                </Text>
              </div>
            )}
          {(data.property === "random split" ||
            data.oparator === conditionOperators.percentageOfYes) && (
            <div className="ml-1 mt-1">
              <Text className="text-xs">
                {(data.valuePercentage ?? 0) + "%"}
              </Text>
            </div>
          )}
        </div>
      )}
      <br />
      <div className="condition-option flex justify-end">
        <div className="relative w-full flex items-center justify-between">
          <div className="absolute left-1/2 -translate-x-1/2">
            <Text className="text-xs">Yes</Text>
          </div>
          {(data.trueCount || data.falseCount) && (
            <div className="group ml-auto mr-[10px]">
              <Badge color="sky">
                <Text className="text-xs hidden group-hover:block">
                  ({data.trueCount ?? 0})
                </Text>
                <Text className="text-xs">
                  {data.trueCount + data.falseCount === 0
                    ? 0
                    : Math.min(
                        100,
                        Math.round(
                          (data.trueCount /
                            (data.trueCount + data.falseCount)) *
                            100,
                        ),
                      )}
                  %
                </Text>
              </Badge>
            </div>
          )}
        </div>

       
        <Handle
          type="source"
          id="true"
          position={Position.Right}
          style={{
            top: "auto",
            bottom: 50,
            right: 5,
          }}
        />
      </div>
      <div className="condition-option flex justify-end">
        <div className="relative w-full flex items-center justify-between">
          <div className="absolute left-1/2 -translate-x-1/2">
            <Text className="text-xs">No</Text>
          </div>
          {(data.trueCount || data.falseCount) && (
            <div className="group ml-auto mr-[10px]">
              <Badge color="sky">
                <Text className="text-xs hidden group-hover:block">
                  ({data.falseCount ?? 0})
                </Text>
                <Text className="text-xs">
                  {data.trueCount + data.falseCount === 0
                    ? 0
                    : Math.min(
                        100,
                        Math.round(
                          (data.falseCount /
                            (data.trueCount + data.falseCount)) *
                            100,
                        ),
                      )}
                  %
                </Text>
              </Badge>
            </div>
          )}
        </div>
       
        <Handle
          type="source"
          id="false"
          position={Position.Right}
          style={{
            top: "auto",
            bottom: 10,
            right: 5,
          }}
        />
      </div>
    </div>
  );
}

export default ConditionNode;
